import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';

import type { IqeProject, TestRun } from '../../interfaces/ui';

interface TestExecutionHistoryProps {
  project: IqeProject;
  runs: TestRun[] | undefined;
  onViewResults?: (projectId: string) => void;
}

export default function TestExecutionHistory({
  project,
  runs,
  onViewResults,
}: TestExecutionHistoryProps) {
  console.log(
    '📋 TestExecutionHistory - runs prop:',
    runs,
    'project:',
    project.name,
  );

  return (
    <Box className="pd-exec-history">
      <Typography variant="h6" className="pd-section-title">
        Execution history
      </Typography>
      <TableContainer className="pd-table-container">
        <Table size="small" className="pd-table" aria-label="Execution history">
          <TableHead className="pd-table-header">
            <TableRow>
              <TableCell className="pd-table-header-title">Run ID</TableCell>
              <TableCell className="pd-table-header-title">
                Execution date
              </TableCell>
              <TableCell className="pd-table-header-title">Status</TableCell>
              <TableCell className="pd-table-header-title">
                Test cases
              </TableCell>
              <TableCell className="pd-table-header-title">Pass rate</TableCell>
              <TableCell className="pd-table-header-title">Failed</TableCell>
              <TableCell className="pd-table-header-title">Healed</TableCell>
              <TableCell className="pd-table-header-title">Duration</TableCell>
              <TableCell className="pd-table-header-title">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {runs?.map((run, index) => (
              <TableRow key={index}>
                <TableCell className="pd-table-cell">
                  {run.transactionId}
                </TableCell>
                <TableCell className="pd-table-cell">
                  {run.createdAt
                    ? `${run.createdAt.toLocaleDateString()} ${run.createdAt.toLocaleTimeString()}`
                    : 'N/A'}
                </TableCell>
                <TableCell className="pd-table-cell">
                  <Typography
                    component="span"
                    className={`pc-badge ${
                      run.passRate >= 80
                        ? 'pc-badge-status-ready'
                        : 'pc-badge-status-failed'
                    }`}
                  >
                    {run.passRate >= 80 ? 'Passed' : 'Failed'}
                  </Typography>
                </TableCell>
                <TableCell className="pd-table-cell">{run.testCases}</TableCell>
                <TableCell className="pd-table-cell">{run.passRate}%</TableCell>
                <TableCell className="pd-table-cell">{run.failed}</TableCell>
                <TableCell className="pd-table-cell">—</TableCell>
                <TableCell className="pd-table-cell">—</TableCell>
                <TableCell>
                  {onViewResults && (
                    <Button
                      variant="text"
                      href={''}
                      size="small"
                      // href={run.dashboardUrl}
                      startIcon={<VisibilityIcon />}
                      color="primary"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pd-view-results-btn"
                    >
                      View test results
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
